export const typography = {
  h4: {
    fontFamily: "GT Walsheim Pro",
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.375,
    // letterSpacing: '0.00735em',
  },
  h5: {
    fontFamily: "GT Walsheim Pro",
    fontSize: '1.2rem',
    fontWeight: 600,
    lineHeight: 1.375,
    // letterSpacing: '0.00735em',
  },
  h6: {
    fontFamily: "GT Walsheim Pro",
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.5,
    // letterSpacing: '0.02857em',
  },
  body1: {
    fontFamily: "GT Walsheim Pro",
    fontSize: '0.875rem',
    fontWeight: 300,
    lineHeight: 1.5,
    // letterSpacing: '0.02857em',
  },
  button: {
    fontFamily: "GT Walsheim Pro",
    fontSize: '0.75rem',
    fontWeight: 700,
    lineHeight: 1.4,
    // letterSpacing: '0.02857em',
  },
  caption: {
    fontFamily: "GT Walsheim Pro",
    fontSize: '0.75rem',
    fontWeight: 300,
    lineHeight: 1.25,
    // letterSpacing: '0.03333em',
  },
}
